// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { DirectPortfolioModelMessage } from "../../../../Utils/DirectMessages/DirectPortfolioModelMessage.js"
import { FieldsFactory } from "../Factory/FieldsFactory.js"
import { MessageProcessorBase } from "./MessageProcessorBase.ts"
import { SEPARATOR } from "../../../../Utils/Enums/Constants.js"

export let PortfolioModelMessageProcessor = function ()
{
    MessageProcessorBase.call(this)
}

PortfolioModelMessageProcessor.prototype = Object.create(MessageProcessorBase.prototype)

PortfolioModelMessageProcessor.prototype.decode = function (fieldSet)
{
    let message = new DirectPortfolioModelMessage(),
        ff = FieldsFactory,
        groups = fieldSet.GetGroups(ff.PORTFOLIO_MODEL_INSTRUMENT_ENTRY_GROUP)

    message.ModelID = fieldSet.GetValue(ff.FIELD_PORTFOLIO_MODEL_ID);
    message.PortfolioSystemID = fieldSet.GetValue(ff.FIELD_PORTFOLIO_SYSTEM_ID);
    message.ModelName = fieldSet.GetValue(ff.FIELD_NAME);
    message.Description = fieldSet.GetValue(ff.FIELD_DESCRIPTION);
    message.DiagramPercent = fieldSet.GetValue(ff.FIELD_PERCENT);

    message.ByInstrumentPercent = {}

    if (groups)
        for (let i = 0; i < groups.length; i++)
        {
            let group = groups[i],
                tradableID = group.GetValue(ff.FIELD_TRADABLE_INSTRUMENT_ID),
                routeID = group.GetValue(ff.FIELD_ROUTE_ID),
                percent = group.GetValue(ff.FIELD_PERCENT)

            let key = PortfolioModelMessageProcessor.CASH_KEY
            if (tradableID && routeID)
                key = tradableID + SEPARATOR + routeID
            message.ByInstrumentPercent[key] = percent
        }

    return [message];
}

PortfolioModelMessageProcessor.CASH_KEY = 'Cash';